import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">About</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              About <span className="text-primary-500">CSSBuyBR</span>.info
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              An independent informational resource for CSSBuy Spreadsheet users. We are not affiliated with CSSBuy.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8 lg:p-10">
              <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed">
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">What is CSSBuyBR.info?</h2>
                <p className="mb-4">
                  CSSBuyBR.info is an independent informational resource designed to help consumers navigate the world of buying agents, specifically CSSBuy. We provide organized resources, guides, and articles about CSSBuy Spreadsheet, shipping, reviews, safety, and more.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Our Mission</h2>
                <p className="mb-4">
                  Our mission is to provide clear, objective, and useful information that helps consumers make informed decisions when using buying agent services. We believe that organized information and transparent guidance lead to better purchasing experiences.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Editorial Policy</h2>
                <ul className="space-y-2 mb-6 list-disc list-inside">
                  <li><strong>Research-based</strong> — All content is based on research and publicly available information.</li>
                  <li><strong>Original analysis</strong> — We provide original analysis and organization of information.</li>
                  <li><strong>Updated information</strong> — We strive to keep content current and accurate.</li>
                  <li><strong>Independent</strong> — We are not affiliated with CSSBuy or any buying agent service.</li>
                  <li><strong>Commercial disclosure</strong> — We do not sell products or process payments.</li>
                </ul>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Important Disclaimer</h2>
                <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg mb-6">
                  <p className="text-sm text-amber-800">
                    CSSBuyBR.info is an independent informational resource and is not the official CSSBuy website. We do not process payments, sell products, or have any affiliation with CSSBuy. Always verify important account, payment, shipping, and policy information through official channels before taking action.
                  </p>
                </div>
                <p className="mb-4">
                  This website exists solely to organize and present information for research and educational purposes. For official services, account management, and purchases, please visit the official CSSBuy platform directly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}